import {getIntegrations} from 'consts/integrations'
import BaseStore from './base-store'
import StoreProxy from './store_proxy'
import {API_INTEGRATIONS} from 'consts/api'
import {oauth as $oauth} from 'utils'
import {INTEGRATIONS_META} from 'consts/integrations'


import * as $utils from 'utils';
export class Integration extends BaseStore {
  constructor(values) {
    super(
      {
        id: undefined,
        enabled: false,
        connected: false,
        type: undefined,
        ...values
      }
    )
  }

  async doSave(rest, changed) {
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    await rest.patch(`${API_INTEGRATIONS}/${this._state.id}`, to_write)
  }

  async doLoad(rest, params) {
    const integration = await rest.get(`${API_INTEGRATIONS}/${this._state.id}`, params)
    Object.assign(this._state, integration)
    this.checkReconnect()
  }

  checkReconnect() {
    const data = getIntegrations().find(x => x.type === this._state.type)
    if (this._state.enabled && !this._state.connected) {
      $utils.toasts.message({
        class: 'integrations',
        displayTime: 60000,
        message: `Your <b>${data.name}</b> credentials have expired. Please reconnect or disable your integration.`,
        showImage: data.logo,
        actions: [
          {
            text: 'Disable',
            class: 'tertiary tiny',
            click: async () => {
              await integrations.delete(this._state.type)
            }
          },
          {
            text: 'Reconnect',
            class: 'primary tiny',
            click: async () => {
              await integrations.connect(this._state.type)
            }
          },
        ]
      })
    }
  }
}

export class Integrations extends BaseStore {
  constructor() {
    super({
      integrations: []
    })
  }

  async doLoad(rest, params) {
    const items = await rest.get(API_INTEGRATIONS, params)
    this._state.integrations = []
    
    for (const item of items) {
      const integration = new Integration(item)
      this._state.integrations.push(integration)
      integration.checkReconnect()
    }
  }

  getIntegration(type) {
    for (let item of this._state.integrations) {
      if (item.type === type) {
        return item
      }
    }
    return undefined
  }

  showSuccessToast(type, message) {
    const data = getIntegrations().find(x => x.type === type)
    $utils.toasts.message({
      showImage: data.logo,
      class: 'success',
      message
    })
  }

  showErrorToast(type, message = 'Something went wrong. Please try again later.') {
    const data = getIntegrations().find(x => x.type === type)
    $utils.toasts.message({
      displayTime: 30000,
      showImage: data.logo,
      class: 'integrations error',
      message
    })
  }

  async connect(type) {
    let integration = this.getIntegration(type)
    if (integration === undefined) integration = await this.newIntegration({type})
    await $oauth.authorize(`${API_INTEGRATIONS}/${integration.id}/authorize`, type)
  }

  async newIntegration(params) {
    const data = await this._rest.post(API_INTEGRATIONS, params)
    const new_integration = new Integration(data)
    this._state.integrations.push(new_integration)
    return new_integration
  }

  async delete(type) {
    const integration = this.getIntegration(type)
    await this._rest.delete(`${API_INTEGRATIONS}/${integration.id}`)
    this._state.integrations = this._state.integrations.filter(x => x.id !== integration.id)
  }

  async enable(type, enabled) {
    const integration = this.getIntegration(type)
    integration.enabled = enabled
    await integration.save()
  }

  calendarEnabled() {
    const mc = this.getIntegration(INTEGRATIONS_META.ms_calendar.type)
    const gc = this.getIntegration(INTEGRATIONS_META.google_calendar.type)
    return mc?.enabled || gc?.enabled
  }

  socialEnabled() {
    const li = this.getIntegration(INTEGRATIONS_META.linkedin.type)
    return li?.enabled
  }
}

const integrations = new StoreProxy(new Integrations(), {array_prop: 'integrations'})
export default integrations
